import { NotFound } from '../components/NotFound.tsx';
import { PageLayout } from '../components/PageLayout.tsx';

export const NotFoundPage = () => {
  return (
    <PageLayout>
      <NotFound />
    </PageLayout>
  );
};
